import { Box, Flex, SimpleGrid, Skeleton, Stack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import TCAPLoader from 'components/TCAPLoader';
import DashboardPanel from './DashboardPanel';

/**
 * (2635) Stand-in for the dashboard home while its sections' first requests
 * settle: the setup progress and account summary panels in outline, with the
 * TCAP animation on top.
 */
const DashboardHomeSkeleton = () => {
    const { darkMode } = useSelector((state) => state.settings);
    const startColor = darkMode ? 'whiteAlpha.200' : 'gray.100';
    const endColor = darkMode ? 'whiteAlpha.300' : 'gray.300';
    const bar = (props) => (
        <Skeleton
            startColor={startColor}
            endColor={endColor}
            borderRadius="md"
            {...props}
        />
    );

    return (
        <Box position="relative" data-testid="dashboard-home-skeleton">
            <DashboardPanel title={bar({ h: 4, w: '180px' })} mb={6}>
                <Flex justify="space-between" mt={6} mb={4} px={6}>
                    {Array.from({ length: 5 }, (_, i) => (
                        <Skeleton
                            key={i}
                            startColor={startColor}
                            endColor={endColor}
                            boxSize={8}
                            borderRadius="full"
                        />
                    ))}
                </Flex>
            </DashboardPanel>
            <DashboardPanel title={bar({ h: 4, w: '140px' })}>
                <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3} mt={3}>
                    {Array.from({ length: 4 }, (_, i) => (
                        <Box key={i}>{bar({ h: 16 })}</Box>
                    ))}
                </SimpleGrid>
                {bar({ h: 8, mt: 5, mb: 3 })}
                <Stack spacing={3}>
                    {Array.from({ length: 3 }, (_, i) => (
                        <Box key={i}>{bar({ h: 20 })}</Box>
                    ))}
                </Stack>
            </DashboardPanel>
            <Flex
                position="absolute"
                inset={0}
                align="center"
                justify="center"
                pointerEvents="none">
                <TCAPLoader showText={false} scale={3} />
            </Flex>
        </Box>
    );
};

export default DashboardHomeSkeleton;
